import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, GiftIcon, PillIcon, ZapIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { productBrand, productEdition, productImage, productImageAlt, totalBonuses, totalVolumes } from '../data/offer';
const highlights = [{
  icon: BookOpenIcon,
  label: `${totalVolumes} professional volumes`
}, {
  icon: GiftIcon,
  label: `${totalBonuses} exclusive bonuses`
}, {
  icon: ZapIcon,
  label: 'Instant access'
}];
export function Hero() {
  const scrollToPricing = () => document.getElementById('pricing')?.scrollIntoView({
    behavior: 'smooth',
    block: 'start'
  });
  return <section className="relative isolate overflow-hidden bg-navy" data-id="element-84" data-mp="sde2mt11vlvr">
      <div className="flex h-1 w-full" aria-hidden="true" data-id="element-85" data-mp="nb6njukxbpp7">
        <span className="flex-1 bg-aqua" data-id="element-86" data-mp="3d1a7phvug7c8" />
        <span className="w-24 bg-gold" data-id="element-87" data-mp="3d2bhzk51cpsw" />
        <span className="flex-1 bg-aqua" data-id="element-88" data-mp="3cz5w0drpe41e" />
      </div>

      <div className="mx-auto max-w-5xl px-4 pb-14 pt-10 text-center lg:pb-20 lg:pt-14" data-id="element-89" data-mp="381nv9anuav4h">
        <motion.p initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="inline-flex items-center gap-2 rounded-full border border-gold/40 bg-navy-light px-4 py-2 text-xs font-semibold uppercase tracking-wider text-pearl" data-id="element-90" data-mp="3j9k9t8cxxbej">
          <PillIcon className="h-4 w-4 shrink-0 text-gold" aria-hidden="true" data-id="element-91" data-mp="30iazwxz9ckmf" /> {productBrand} · {productEdition}
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.12,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto mt-8 max-w-3xl" data-id="element-92" data-mp="359szpipjof5t">
          <img src={productImage} alt={productImageAlt} className="mx-auto w-full" style={{
          filter: 'drop-shadow(0 0 28px rgba(201, 162, 74, 0.35)) drop-shadow(0 0 64px rgba(201, 162, 74, 0.18))'
        }} data-id="element-93" data-mp="2hjf2zew0ls4w" />
        </motion.div>

        <div className="mt-9" data-id="element-94" data-mp="s3mcg0c5huxb">
          <Button onClick={scrollToPricing} arrow className="w-full sm:w-auto" data-id="element-95" data-mp="s3ur9xru3ab5">
            Get your professional edition now
          </Button>
        </div>

        <ul className="mt-7 flex flex-wrap justify-center gap-2 text-xs font-medium text-pearl" data-id="element-96" data-mp="id02omr47ymj">
          {highlights.map(({
          icon: Icon,
          label
        }) => <li key={label} className="inline-flex items-center gap-1.5 rounded-md border border-white/15 bg-navy-light px-3 py-2" data-id="element-97" data-mp="1b1fgj5yigawa">
              <Icon className="h-3.5 w-3.5 text-aqua-light" aria-hidden="true" data-id="element-98" data-mp="163454qskhsby" />
              {label}
            </li>)}
        </ul>
      </div>
    </section>;
}